import { Text, Flex, Heading, Stack } from "@chakra-ui/react";
import React from "react";
import CommonContainer from "../components/shared/CommonContainer";

export default function PrivacyPolicyPage() {
  return (
    <>
      <Flex
        alignItems="center"
        justifyContent="center"
        height={{ base: "200px", md: "300px" }}
        bgGradient="linear(to-b,#0079BC,#74C7F5)"
        color="white"
      >
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "22px", md: 36 }}
          pb={{ base: 10, md: 20 }}
        >
          Decolance Privacy Policy
        </Heading>
      </Flex>
      <CommonContainer>
        <Stack
          bg="brand.50"
          p={10}
          pos="relative"
          bottom={20}
          borderRadius={10}
          fontSize={{ md: "19px" }}
        >
          <Text pb={4} color="black">
            Last Update: January 10, 2023
          </Text>
          <Text color="#8f8f8f" pb={10}>
            Welcome to Decolance.io
            <br />
            <br />
            Please read this privacy statement (the "Policy") carefully to gain
            an understanding of how Decolance ("Decolance'', "we") handles
            personal information. By accessing or using www.decolance.io, the
            Decolance mobile app, or any other related sites, applications,
            services, or goods, or any other website operated by Decolance that
            links to this policy (each, the "Site"), you confirm that you have
            read and comprehend this Policy. This Policy is subject to change;
            any modifications will be posted on this Site, and we will take any
            additional steps required by law, including notifying you of
            substantive changes. Changes to this Policy are effective as of the
            date labeled "Last Revised." We recommend that you periodically
            review the Policy for any updates or modifications.
            <br />
            <br />
            Information We Collect – The majority of the information we collect
            comes directly from you: when you register for the Site, use it,
            fill out forms, or register for any of our programs. We also collect
            information regarding your communications with Decolance, any posts
            you make on our blogs or forums, and your interactions with other
            Decolance users. In addition, we collect information automatically
            when you access, browse, view, or otherwise use the Site, and we
            receive information from third-party vendors and other sources.
            <br />
            <br />
            Our Legal Justification for Using Your Personal Data - In accordance
            with applicable laws, all processing of your personal information
            will be justified by one of the "lawful grounds" listed below.
            <br />
            <br />
            How do we utilize the collected information? – We use personal
            information to provide you with quality service and security, to
            operate the Site, to understand how people use the Site, and to
            fulfill our obligations to you; to ensure marketplace integrity and
            security; to prevent fraud; to contact you and send you direct
            marketing communications; to promote the Site, our services, and the
            Decolance marketplace; to comply with lawful requests from public
            authorities and to comply with applicable laws and regulations.
            <br />
            <br />
            We will only retain personal information for as long as it is
            necessary to fulfill the purpose for which it was collected. In
            certain instances, we will retain personal information for longer
            durations.
            <br />
            <br />
            Children - This website is available to users who are at least 18
            years old and of legal contracting age. Minors under the age of 18
            and at least 13 years old are only permitted to use the Site with
            the permission of a parent or legal guardian who owns an account on
            their behalf. No one under the age of 13 is permitted to use this
            website or our services. We do not collect personal information from
            children under 13 years of age.
            <br />
            <br />
            Sharing Personal Information with Third Parties – We share personal
            information with third parties in order to operate the Site, provide
            you with our services, comply with applicable laws and regulations,
            and prevent fraud, infringements, and illegal activities.
            <br />
            <br />
            Some of the personal information you provide to us may be stored or
            processed on our behalf by third party suppliers and data processors
            located in other jurisdictions, such as the United States and
            Israel.
            <br />
            <br />
            Cookies - We use cookies and similar technologies (such as web
            beacons, pixels, tags, and scripts) to enhance and personalize your
            experience, provide our services, analyze the performance of our
            website, and for marketing purposes.
            <br />
            <br />
            Do Not Track (DNT) – Our Site does not respond to Do Not Track (DNT)
            signals.
            <br />
            <br />
            External Links - The Site contains links to third party sites, and
            if you link to a third party site from the Site, any data you
            provide to that site and any use of that data by the third party are
            not subject to Decolance's control and are not covered by this
            Policy.
            <br />
            <br />
            Security – We implement technical and organizational measures to
            maintain the security of the Site and your personal information and
            in preventing unauthorized access, loss, misuse, alteration,
            destruction or damage to it through industry standard technologies
            and internal procedures.
            <br />
            <br />
            Users' rights in the EU, EEA, and UK - Whenever we process personal
            data pertaining to EU, EEA, or UK users, the terms outlined below
            apply in relation to your rights as a data subject under EU data
            protection laws.
            <br />
            <br />
            Provisions Specific to California Residents If you are a California
            resident, you are entitled to the rights outlined below.
            <br />
            <br />
            We take steps to ensure that the personal information we collect is
            accurate and up-to-date, and we give you the option to update your
            information via your account's profile settings. If you believe that
            your information is incorrect or incomplete in any way, please let
            us know immediately.
            <br />
            <br />
            Contact Us - You can exercise your rights over your personal
            information, by contacting us at privacy@decolance.io. For users of
            Decolance Workspace, please contact workspace-support@decolance.io.
            <br />
            <br />
            These are merely the highlights. We encourage you to read the full
            version of our Policy below to learn more about the information we
            collect, how we use it, the meaning of cookies (no, you can't eat
            them), and more.
          </Text>
        </Stack>
      </CommonContainer>
    </>
  );
}
